import React, { useMemo } from 'react'
import {
  BasicListingSEO,
  BasicListingSEOProps,
  useAllSelectedFilters,
  useListingFilters,
  getTermsAggregationLabel,
  useLocalLabels,
} from '@sentecacommerce-theme/lib'
import { Labels } from '../../listingPage.props'

const labelGettersMap: any = {
  terms: getTermsAggregationLabel,
  ranges: (
    filter: any,
    labelUnder?: string,
    labelOver?: string,
    labelBgn?: string
  ) => {
    if (filter.data.from === '*') {
      return `${labelUnder} ${filter.data.to / 100}${labelBgn}`
    }

    if (filter.data.to === '*') {
      return `${labelOver} ${filter.data.from / 100}${labelBgn}`
    }

    return `${filter.data.from / 100}${labelBgn} - ${
      filter.data.to / 100
    }${labelBgn}`
  },
}

export const ListingSEO = ({ data }: { data: BasicListingSEOProps }) => {
  const { data: filters } = useListingFilters()
  const labels = useLocalLabels<Labels>()

  const selectedFilters = useAllSelectedFilters((filters as any) || [])

  const formattedData = useMemo(() => {
    const selectedFiltersLabel = selectedFilters
      .map((filter) => {
        return (
          labelGettersMap[filter.aggregationType || '']?.(
            filter,
            labels?.labelUnder,
            labels?.labelOver,
            labels?.labelBgn
          ) || null
        )
      })
      .filter((f) => Boolean(f))
      .join(', ')
      .trim()

    return {
      ...data,
      titleTemplate: data.titleTemplate?.replace(
        ':selected_filters:',
        selectedFiltersLabel ? ' ' + selectedFiltersLabel : ''
      ),
      descriptionTemplate: data.descriptionTemplate?.replace(
        ':selected_filters:',
        selectedFiltersLabel ? ' ' + selectedFiltersLabel : ''
      ),
    }
  }, [data, labels, selectedFilters])

  return <BasicListingSEO {...formattedData} />
}
